<template>
	<article>
		<section class="xbed-sub-title">
			<span>支付单列表</span>
		</section>

		<section class="xbed-breadcrumb">
			<Breadcrumb>
				<BreadcrumbItem>订单管理</BreadcrumbItem>
				<BreadcrumbItem>支付单列表</BreadcrumbItem>
			</Breadcrumb>
		</section>

		<Tabs class="tabs add-distance" @on-click="toggleTab">
			<TabPane label="支付单项目列表" name="projectList" ref="projectList">
				<Form :model="projectForm" inline>
					<Row>
						<FormItem label="创建日期：" prop="createDate" :label-width="90">
							<DatePicker v-model="projectForm.createDate" @on-change="dateRange => {changeDate(dateRange, 'projectForm', 'createDate')}" :clearable="false" format="yyyy-MM-dd" type="daterange" placeholder="选择日期" style="width: 200px"></DatePicker>
						</FormItem>
						<FormItem label="项目：" prop="project" :label-width="90">
							<Select v-model="projectForm.project" filterable>
								<Option v-for="(item, index) in projectType" :key="index" :value="index">{{item}}</Option>
							</Select>
						</FormItem>
						<FormItem label="支付方式：" prop="payWay" :label-width="90">
							<Select v-model="projectForm.payWay" filterable>
								<Option v-for="(item, index) in payMethodType" :key="index" :value="index">{{item}}</Option>
							</Select>
						</FormItem>
						<FormItem label="订单来源：" prop="source" :label-width="90">
							<Select v-model="projectForm.source" filterable>
								<Option value="S00">全部</Option>
								<Option v-for="(orderSource, index) in sourceType" :key="index" :value="orderSource.id">{{orderSource.name}}</Option>
							</Select>
						</FormItem>
					</Row>
					<Row>
						<FormItem label="订单号：" prop="orderNo" :label-width="90">
							<Input type="text" v-model="projectForm.orderNo"></Input>
						</FormItem>
						<FormItem label="支付单号：" prop="payNo" :label-width="90">
							<Input type="text" v-model="projectForm.payNo"></Input>
						</FormItem>
						<FormItem label="支付人：" prop="payName" :label-width="90">
							<Input type="text" v-model="projectForm.payName"></Input>
						</FormItem>
						<FormItem prop="query">
							<Button type="primary" @click="queryListPayProjectReport">查询</Button>
						</FormItem>
						<FormItem prop="export">
							<Button type="primary" @click="exportListPayProjectReport">导出excel</Button>
						</FormItem>
					</Row>
				</Form>
				<Table stripe :loading="projectList.loading" ref="orderReportTable" :columns="columns.projectList" :data="projectList.data"></Table>
				<div style="margin: 10px;overflow: hidden">
					<Page show-sizer placement="top" :total="projectList.count" :current="projectList.page" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
				</div>
			</TabPane>
			<TabPane label="线下支付确认收款表" name="offlineList" ref="offlineList">
				<Form :model="offlineForm" inline>
					<Row>
						<FormItem label="支付日期：" prop="payTime" :label-width="90">
							<DatePicker v-model="offlineForm.payTime" @on-change="dateRange => {changeDate(dateRange, 'offlineForm', 'payTime')}" :clearable="false" format="yyyy-MM-dd" type="daterange" placeholder="选择日期" style="width: 200px"></DatePicker>
						</FormItem>
						<FormItem label="订单号：" prop="orderNo" :label-width="90">
							<Input type="text" v-model="offlineForm.orderNo"></Input>
						</FormItem>
						<FormItem label="支付单号：" prop="payNo" :label-width="90">
							<Input type="text" v-model="offlineForm.payNo"></Input>
						</FormItem>
					</Row>
					<Row>
						<FormItem label="预订渠道：" prop="orderSource" :label-width="90">
							<Select v-model="offlineForm.orderSource" filterable>
								<Option value="S00">全部</Option>
								<Option v-for="(orderSource, index) in sourceType" :key="index" :value="orderSource.id">{{orderSource.name}}</Option>
							</Select>
						</FormItem>
						<FormItem label="支付方式：" prop="payWay" :label-width="90">
							<Select v-model="offlineForm.payWay" filterable>
								<Option v-for="(type, index) in payMethodType" v-if="index==0||index>6&&index<12" :key="index" :value="index">{{type}}</Option>
							</Select>
						</FormItem>
						<FormItem label="确认状态：" prop="status" :label-width="90">
							<Select v-model="offlineForm.status" filterable>
								<Option value="S00">全部</Option>
								<Option :value="1">待确认</Option>
								<Option :value="2">已确认</Option>
								<Option :value="3">异常</Option>
							</Select>
						</FormItem>
						<FormItem>
							<Button type="primary" @click="queryListOfflinePayment">查询</Button>
						</FormItem>
					</Row>
				</Form>
				<Table stripe :loading="offlineList.loading" ref="orderReportTable" :columns="columns.offlineList" :data="offlineList.data"></Table>
				<div style="margin: 10px;overflow: hidden">
					<Page show-sizer placement="top" :total="offlineList.count" :current="offlineList.page" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
				</div>
			</TabPane>
			<TabPane label="支付单列表" name="paymentList" ref="paymentList" class="add-tabpane-distance">
				<Form :model="paymentForm" inline>
					<Row>
						<FormItem label="创建日期：" prop="createDate" :label-width="90">
							<DatePicker v-model="paymentForm.createDate" @on-change="dateRange => {changeDateLimit(dateRange, 'paymentForm', 'createDate')}" :clearable="false" format="yyyy-MM-dd" type="daterange" placeholder="选择日期" style="width: 200px"></DatePicker>
						</FormItem>
						<FormItem label="支付日期：" prop="payTime" :label-width="90">
							<DatePicker v-model="paymentForm.payTime" @on-change="dateRange => {changeDate(dateRange, 'paymentForm', 'payTime')}" :clearable="true" format="yyyy-MM-dd" type="daterange" placeholder="选择日期" style="width: 200px"></DatePicker>
						</FormItem>
						<FormItem label="结账月份：" prop="settleDateMonth" :label-width="90">
							<DatePicker v-model="paymentForm.settleDateMonth" :clearable="true" type="month" placeholder="选择日期" style="width: 200px"></DatePicker>
						</FormItem>
						<FormItem label="订单号：" prop="orderNo" :label-width="90">
							<Input type="text" v-model="paymentForm.orderNo" @on-blur="trimlrSpace(paymentForm,'orderNo')"></Input>
						</FormItem>
						<FormItem label="OTA单号：" prop="otaNo" :label-width="90">
							<Input type="text" v-model="paymentForm.otaNo" @on-blur="trimlrSpace(paymentForm,'otaNo')"></Input>
						</FormItem>
					</Row>
					<Row>
						<FormItem label="支付单号：" prop="payNo" :label-width="90">
							<Input type="text" v-model="paymentForm.payNo" @on-blur="trimlrSpace(paymentForm,'payNo')"></Input>
						</FormItem>
						<FormItem label="结算单号：" prop="settlementNo" :label-width="90">
							<Input type="text" v-model="paymentForm.settlementNo" @on-blur="trimlrSpace(paymentForm,'settlementNo')"></Input>
						</FormItem>
						<FormItem label="预订渠道：" prop="orderSource" :label-width="90">
							<Select v-model="paymentForm.orderSource" filterable>
								<Option value="S00">全部</Option>
								<Option v-for="(orderSource, index) in sourceType" :key="index" :value="orderSource.id">{{orderSource.name}}</Option>
							</Select>
						</FormItem>
					</Row>
					<Row>
						<FormItem label="支付方式：" prop="payType" :label-width="90">
							<Select v-model="paymentForm.payType" filterable>
								<Option v-for="(type, index) in payMethodType" :key="index" :value="index">{{type}}</Option>
							</Select>
						</FormItem>
						<FormItem label="对账状态：" prop="accountState" :label-width="90">
							<Select v-model="paymentForm.accountState" filterable>
								<Option value="S00">全部</Option>
								<Option :value="1">未对账</Option>
								<Option :value="2">已对账</Option>
								<Option :value="3">异常</Option>
							</Select>
						</FormItem>
						<FormItem label="收款状态：" prop="receiptState" :label-width="90">
							<Select v-model="paymentForm.receiptState" filterable>
								<Option value="S00">全部</Option>
								<Option :value="1">未收款</Option>
								<Option :value="2">已收款</Option>
								<Option :value="3">异常</Option>
							</Select>
						</FormItem>
					</Row>
					<Row>
						<FormItem>
							<Button type="primary" @click="queryListPayInfoReport">查询</Button>
						</FormItem>
						<FormItem style="margin-left: 80px;">
							<Button type="primary" @click="exportFilterResult" :loading="exportBtn.exportFilterResult">导出筛选结果</Button>
						</FormItem>
						<FormItem>
							<Button type="primary" @click="openDownloadTemplateModal">下载导入模板</Button>
						</FormItem>
						<FormItem>
							<Button type="primary" @click="openImportModal('account')">导入对账单</Button>
						</FormItem>
						<FormItem>
							<Button type="primary" @click="openImportModal('receipt')">导入收款单</Button>
						</FormItem>
						<FormItem>
							<Button type="primary" @click="openEditPriceModel">批量修正金额</Button>
						</FormItem>
						<FormItem>
							<Button type="primary" @click="viewImportRecords">对账收款导入记录</Button>
						</FormItem>
						<FormItem>
							<Button type="primary" @click="editRecord">批量修正金额导入记录</Button>
						</FormItem>
					</Row>
				</Form>
				<Table stripe :loading="paymentList.loading" ref="orderReportTable" :columns="columns.paymentList" :data="paymentList.data"></Table>
				<div style="float: left;margin: 10px;overflow: hidden">
					<Page show-sizer placement="top" :total="paymentList.count" :current="paymentList.page" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
				</div>
			</TabPane>
		</Tabs>
		<!-- ***********************批量修正金额********************** -->
    <!-- 批量修正金额 -->
		<Modal v-model="editPriceModel.display" ref="importeditPriceModel" :loading="false" :width="500" title="批量修正金额">
			<Row>
				<Col span="18">
					<span>下载模板：</span>
					<Button type="primary" @click="openEditPriceDownLoad">点击下载</Button>
				</Col>
				<Col span="18" style="margin:15px 0;">
					<span>文件：</span>
					<span>{{editPriceModel.importModalInfo.filename?editPriceModel.importModalInfo.filename:"文件名.xlsx/xls"}}</span>
				</Col>
				<Col span="6">
					<Upload :action="editPriceModel.uploadData.action" name="file" :format="['xlsx','xls']" ref="files" :data="editPriceModel.uploadData.form" :before-upload="editBeforeUpload" :on-success="editUploadSuccess" :on-error="editUploadError" :show-upload-list="false">
						<Button type="primary" icon="ios-cloud-upload-outline">上传文件</Button>
					</Upload>
				</Col>
			</Row>
			<div slot="footer">
				<Button type="text" :disabled="editPriceModel.importButtonLoading" @click="editResetImport">取消</Button>
				<Button type="primary" :loading="editPriceModel.importButtonLoading" @click="editprepareImport">开始导入</Button>
			</div>
		</Modal>
		<!-- 批量修正金额成功弹窗 -->
		<Modal v-model="editRecordDisplay" title="提示" :loading="false">
      <p style="fontSize:14px;">文件提交成功，系统正在处理，请勿重复提交！</p>
      <p style="fontSize:14px;">稍等几分钟后可以查看本次导入记录</p>
      <p style="fontSize:14px;">批量修正失败的支付单金额需要人工修正</p>
			<div slot="footer">
				<Button type="text" @click="editCancel">取消</Button>
				<Button type="primary" @click="editRecord">批量修正金额导入记录</Button>
			</div>
    </Modal>
		<!-- 批量修正金额失败弹窗 -->
		<Modal v-model="editRecordFailDisplay" title="提示" :loading="false">
      <p style="fontSize:14px;">文件提交失败,请检查文件重新提交！</p>
      <p style="fontSize:14px;">失败原因：{{editRecordFailDisRemark}}</p>
			<div slot="footer">
				<Button type="primary" @click="editFailRecord">知道了</Button>
			</div>
    </Modal>
		<!-- *********************导入对账收款单*********************** -->
		<Modal v-model="importModalDisplay" ref="importOrderModal" :loading="true" :width="500" :title="importModalInfo.title">
			<Form inline v-if="chooseDate">
				<FormItem label="结账月份：" prop="date" :label-width="90" inline style="width:440px;">
					<Select v-model="importModalInfo.date"> 
						<Option v-for="item in setDate" :key="item.id" :value='item.settleDate'>{{item.settleDate}}</Option>
					</Select>
				</FormItem>
			</Form>
			<Row type="flex" justify="center" align="middle" style="font-size:14px;color:#495060;">
				<Col span="17">
					<span>文件：</span>
					<span>{{importModalInfo.filename?importModalInfo.filename:"文件名.xlsx"}}</span>
				</Col>
				<Col span="6">
					<Upload :action="uploadData.action" name="file" :format="['xlsx']" ref="file" :data="uploadData.form" :before-upload="beforeUpload" :on-success="uploadSuccess" :on-error="uploadError" :show-upload-list="false">
						<Button type="primary" icon="ios-cloud-upload-outline">上传文件</Button>
					</Upload>
				</Col>
			</Row>
			<div slot="footer">
				<Button type="text" :disabled="importmodalButtonLoading" @click="resetImport">取消</Button>
				<Button type="primary" :loading="importmodalButtonLoading" @click="prepareImport">开始导入</Button>
			</div>
		</Modal>
		<Modal v-model="resultModalDisplay" ref="resultModal" :width="1000" title="导入结果" ok-text="下载匹配结果" cancel-text="关闭" @on-ok="downloadResult" :loading="exportBtn.downloadResult" @on-cancel="resetImport">
			<Table stripe ref="orderReportTable" :columns="importResultColumn" :data="importResultData"></Table>
		</Modal>
		<Modal v-model="detailModalDisplay" ref="detailModal" :width="1000" title="修正/状态/明细">
			<Row>
				<Col span="4" class-name="text-align-right">支付单号：</Col>
				<Col span="8">{{stateDetailData.baseInfo.payNo}}</Col>
				<Col span="4" class-name="text-align-right">支付时间：</Col>
				<Col span="8">{{stateDetailData.baseInfo.payTime}}</Col>
			</Row>
			<Row class-name="add-distance">
				<Col span="4" class-name="text-align-right">支付方式：</Col>
				<Col span="8">{{stateDetailData.baseInfo.payTypeName}}</Col>
				<Col span="4" class-name="text-align-right">总金额：</Col>
				<Col span="8">{{typeof stateDetailData.baseInfo.price == 'number' ? (stateDetailData.baseInfo.price / 100).toFixed(2) : stateDetailData.baseInfo.price}}</Col>
			</Row>
			<Row class-name="add-distance">
				<Col span="4" class-name="text-align-right">xbed实收：</Col>
				<Col span="8">{{typeof stateDetailData.baseInfo.payPrice == 'number' ? (stateDetailData.baseInfo.payPrice / 100).toFixed(2):stateDetailData.baseInfo.payPrice}}</Col>
				<Col span="4" class-name="text-align-right">当前退款金额：</Col>
				<Col span="8">{{typeof stateDetailData.baseInfo.refundAmount == 'number'?(stateDetailData.baseInfo.refundAmount / 100).toFixed(2):stateDetailData.baseInfo.refundAmount}}</Col>
			</Row>
			<Row type="flex" justify="center" align="middle" class-name="add-distance">
				<Col span="4" class-name="text-align-right">对账状态：</Col>
				<Col span="8">
					<Row type="flex" justify="start" align="middle">
						<Col>{{stateDetailData.baseInfo.accountState}}</Col>
						<Col v-show="stateDetailData.baseInfo.showButton && stateDetailData.baseInfo.receiptState==='未收款' || stateDetailData.baseInfo.receiptState==='异常'" style="margin-left: 20px;">
							<Button type="primary" size="small" @click="openEditStateModal('account',stateDetailData.baseInfo.accountState)">修改</Button>
						</Col>
					</Row>
				</Col>
				<Col span="4" class-name="text-align-right">收款状态：</Col>
				<Col span="8">
					<Row type="flex" justify="start" align="middle">
						<Col>{{stateDetailData.baseInfo.receiptState}}</Col>
						<Col v-show="stateDetailData.baseInfo.showButton && stateDetailData.baseInfo.receiptState!=='已收款'" style="margin-left: 20px;">
							<Button type="primary" size="small" @click="openEditStateModal('receipt',stateDetailData.baseInfo.receiptState)">修改</Button>
						</Col>
					</Row>
				</Col>
			</Row>
			<Row class-name="add-distance">
				<Col span="4" class-name="text-align-right">备注：</Col>
				<Col span="20">
					<p v-for="(remark, index) in stateDetailData.baseInfo.remark" :key="index" class="wrap_myself">{{remark}}</p>
				</Col>
			</Row>
			<div style="margin-top: 20px;font-size: 16px;">关联子入住单</div>
			<Table stripe ref="accountTable" :loading="stateDetailData.tableLoading" :columns="stateDetailColumns.relateChildOrder" :data="stateDetailData.relateChildOrder"></Table>
			<div style="margin-top: 20px;font-size: 16px;">对账记录</div>
			<Table stripe ref="accountTable" :loading="stateDetailData.tableLoading" :columns="stateDetailColumns.account" :data="stateDetailData.account"></Table>
			<div style="margin-top: 20px;font-size: 16px;">收款记录</div>
			<Table stripe ref="receiptTable" :loading="stateDetailData.tableLoading" :columns="stateDetailColumns.receipt" :data="stateDetailData.receipt"></Table>
			<section slot="footer"></section>
		</Modal>
		<Modal v-model="confirmStateModalDisplay" ref="confirmStateModal" :loading="true" :width="500" title="确认状态" ok-text="提交" @on-ok="prepareConfirmStatus" @on-cancel="cancelConfirmState">
			<Form :model="confirmStateModalForm" ref="confirmStateModalForm" :rules="confirmStateValidate">
				<FormItem label="状态：" prop="state" :label-width="100">
					<Select v-model="confirmStateModalForm.state" @on-change='selectChange'>
						<Option :value="2">已确认</Option>
						<Option :value="3">异常</Option>
					</Select>
				</FormItem>
				<FormItem label="结账月份：" prop="setDate" :label-width="100" v-if="confirmStateModalForm.state === 2">
					<Select v-model="confirmStateModalForm.setDate"> 
						<Option v-for="item in setDate" :key="item.id" :value='item.settleDate'>{{item.settleDate}}</Option>
					</Select>
				</FormItem>
				<FormItem v-show="confirmStateModalForm.state!==3" label="收款渠道：" prop="receiveWay" :label-width="100">
					<Select v-model="confirmStateModalForm.receiveWay" ref="confirmReceiveWay">
						<Option :value="1">微信</Option>
						<Option :value="2">支付宝</Option>
						<Option :value="3">银联</Option>
						<Option :value="4">现金</Option>
					</Select>
				</FormItem>
				<FormItem label="备注：" prop="remark" :label-width="100">
					<Input type="textarea" v-model="confirmStateModalForm.remark" placeholder="必填"></Input>
				</FormItem>
			</Form>
		</Modal>
		<Modal v-model="editStateModalDisplay" ref="editStateModal" :loading="true" :width="500" :title="editStateModalForm.title" ok-text="提交" @on-ok="prepareEditState" @on-cancel="cancelEditState">
			<Form :model="editStateModalForm">
				<FormItem label="状态：" prop="modalState" :label-width="90">
					<Select v-if="editStateModalForm.type==1" key="account" v-model="editStateModalForm.state">
						<Option :value="1">未对账</Option>
						<Option :value="2">已对账</Option>
						<Option :value="3">异常</Option>
					</Select>
					<Select v-if="editStateModalForm.type==2" key="receipt" v-model="editStateModalForm.state">
						<Option :value="1">未收款</Option>
						<Option :value="2" v-if="stateDetailData.baseInfo.accountState =='已对账'">已收款</Option>
						<Option :value="3">异常</Option>
					</Select>
				</FormItem>
				<FormItem label="结账月份：" prop="setDate" :label-width="90" inline v-if="editStateModalForm.type == 1 && editStateModalForm.state === 2">
					<Select v-model="editStateModalForm.setDate"> 
						<Option v-for="item in setDate" :key="item.id" :value='item.settleDate'>{{item.settleDate}}</Option>
					</Select>
				</FormItem>
				<FormItem label="备注：" prop="modalKeyWord" :label-width="90">
					<Input type="textarea" v-model="editStateModalForm.remark" placeholder="必填" @on-blur="trimlrSpace(editStateModalForm,'remark')"></Input>
				</FormItem>
			</Form>
		</Modal>
		<Modal v-model="downloadTemplateModalDisplay" :width="500" title="请选择下载模板类型">
			<Row>
				<Col span="6" offset="3">
					<Button type="primary" @click="downloadTemplate(1)">对账表</Button>
				</Col>
				<Col span="6" offset="6">
					<Button type="primary" @click="downloadTemplate(2)">收款表</Button>
				</Col>
			</Row>
			<div slot="footer"></div>
		</Modal>
		<Modal v-model="correction.display" title="修正" :width="800" @on-ok="preSubFinanceInfo" @on-cancel='clearObjReason' :loading="true" ref="correctionModal" ok-text='确认提交'>
			<Form ref="formValidate" :model="formValidate" :rules="ruleValidate">
				<FormItem label="修正原因" :label-width="80" prop="reason">
					<Input type="textarea" v-model="formValidate.reason" @on-blur="trimlrSpace(formValidate,'reason')"></Input>
				</FormItem>
			</Form>
			<div class="table">
				<div class="table-row">
					<div class="border-right"><strong>原子入住单</strong> </div>
					<div class="border-right"><strong>调整为</strong> </div>
					<div><strong>差额</strong> </div>
				</div>
				<div class="table-row">
					<!-- <div class="text-align-left">开始结束日期：{{financeInfo.orgPreCheckinTime ? financeInfo.orgPreCheckinTime.split(" ")[0] : ""}}至{{financeInfo.orgActualCheckoutTime ? financeInfo.orgActualCheckoutTime.split(" ")[0] : ' -'}}</div> -->
					<div class="text-align-left">开始结束日期：{{financeInfo.showCheckinTime ? financeInfo.showCheckinTime.split(" ")[0] : ""}}至{{financeInfo.showCheckoutTime ? financeInfo.showCheckoutTime.split(" ")[0] : ' -'}}</div>
					<div class="text-align-left">
						<DatePicker type="daterange" style="width:100%" v-model="financeArr"></DatePicker>
					</div>
					<div>{{diffDays}} 房晚</div>
				</div>
				<div class="table-row">
					<div class="text-align-left">房费原价：{{financeInfo.orgRoomPrice | initPrice}}</div>
					<div class="text-align-left">
						<InputNumber :formatter="limitNumber" :parser="limitNumber" style="width:100%" v-model="cus.roomPrice"></InputNumber>
					</div>
					<div>{{roomPriceDiff | initPrice}}</div>
				</div>
				<div class="table-row">
					<div class="text-align-left">业主优惠：{{financeInfo.orgOwnerBear | initPrice}}</div>
					<div class="text-align-left">
						<InputNumber :formatter="limitNumber" :parser="limitNumber" style="width:100%" v-model="cus.ownerBear"></InputNumber>
					</div>
					<div>{{ownerBearDiff | initPrice}}</div>
				</div>
				<div class="table-row">
					<div class="text-align-left">Xbed优惠：{{financeInfo.orgXbedBear | initPrice}}</div>
					<div class="text-align-left">
						<InputNumber :formatter="limitNumber" :parser="limitNumber" style="width:100%" v-model="cus.xbedBear"></InputNumber>
					</div>
					<div>{{xbedBearDiff | initPrice}}</div>
				</div>
				<div class="table-row">
					<div class="text-align-left">应付：{{financeInfo.orgShouldPay | initPrice}}</div>
					<!-- 自动算（原价-业主优惠-xbed优惠）=  -->
					<div class="text-align-left">
						{{(cus.roomPrice - cus.ownerBear - cus.xbedBear) * 100 | initPrice}}（原价-业主优惠-xbed优惠）
					</div>
					<div>{{shouldPayDiff | initPrice}}</div>
				</div>
				<div class="table-row">
					<div class="text-align-left">OTA佣金：{{financeInfo.orgChannelCommission | initPrice}}</div>
					<div class="text-align-left">
						<InputNumber :formatter="limitNumber" :parser="limitNumber" style="width:100%" v-model="cus.channelCommission"></InputNumber>
					</div>
					<div>{{channelCommissionDiff | initPrice}}</div>
				</div>
				<div class="table-row">
					<div class="text-align-left">渠道活动费：{{financeInfo.orgOtherChannelExpenses | initPrice}}</div>
					<div class="text-align-left">
						<InputNumber :formatter="limitNumber" :parser="limitNumber" style="width:100%" v-model="cus.otherChannelExpenses">0.00</InputNumber>
					</div>
					<div>{{otherChannelExpensesDiff | initPrice}}</div>
				</div>
				<div class="table-row">
					<div class="text-align-left">业主推广费：{{financeInfo.orgOwnerPromotionExpense | initPrice}}</div>
					<div class="text-align-left">
						<InputNumber :formatter="limitNumber" :parser="limitNumber" style="width:100%" v-model="cus.ownerPromotionExpense">0.00</InputNumber>
					</div>
					<div>{{ownerPromotionExpenseDiff | initPrice}}</div>
				</div>
				<div class="table-row">
					<div class="text-align-left">卡券金额：{{financeInfo.orgCardRealPrice | initPrice}}</div>
					<div class="text-align-left">
						<InputNumber :formatter="limitNumber" :parser="limitNumber" style="width:100%" v-model="cus.cardRealPrice">0.00</InputNumber>
					</div>
					<div>{{cardRealPriceDiff | initPrice}}</div>
				</div>
				<!-- <div class="table-row">
          <div class="text-align-left">Xbed推广费：{{financeInfo.orgXbedPromotionExpense | initPrice}}</div>
          <div class="text-align-left">
            <InputNumber :formatter="limitNumber" :parser="limitNumber" style="width:100%" v-model="cus.xbedPromotionExpense">0.00</InputNumber>
          </div>
          <div>{{xbedPromotionExpenseDiff | initPrice}}</div>
        </div> -->
				<div class="table-row">
					<div class="text-align-left">Xbed实收：{{financeInfo.orgReceivedPrice | initPrice}}</div>
					<!-- 自动算（应付-佣金-渠道活动费） -->
					<div class="text-align-left">
						{{(cus.roomPrice - cus.ownerBear - cus.xbedBear - cus.channelCommission - cus.otherChannelExpenses) * 100 | initPrice}}（应付-佣金-渠道活动费）
					</div>
					<div>{{receivedPriceDiff | initPrice}}</div>
				</div>
				<div class="table-row">
					<div class="text-align-left">结算房费：{{financeInfo.orgSettlementPrice | initPrice}}</div>
					<!-- 自动算（原价-业主优惠） -->
					<div class="text-align-left">
						{{(cus.roomPrice - cus.ownerBear) * 100 | initPrice}}（原价-业主优惠）
					</div>
					<div>{{settlementPriceDiff | initPrice}}</div>
				</div>
				<!-- 屏蔽 平台服务费 和 推广费返还 -- 2019-10-09  by lty -->
				<!-- <div class="table-row">
					<div class="text-align-left">平台服务费：{{financeInfo.orgPlatformPrice | initPrice}}</div> -->
					<!-- 自动算（结算房费 * 平台服务费率） -->
					<!-- <div class="text-align-left">
						{{ cumPlatformPrice | initPrice}}（结算房费 * 7%） -->
						<!-- <InputNumber :formatter="limitNumber" :parser="limitNumber" style="width:100%" v-model="cus.platformPrice">0.00</InputNumber> -->
					<!-- </div>
					<div>{{ platformPriceDiff | initPrice}}</div>
				</div> -->
				<!-- <div class="table-row">
					<div class="text-align-left">推广费返还：{{financeInfo.orgPromotionExpenseBack | initPrice}}</div>
					<div class="text-align-left">
						{{cumPromotionExpenseBack | initPrice}}（原推广费返还/原平台服务费*新平台服务费） -->
						<!-- <InputNumber :formatter="limitNumber" :parser="limitNumber" style="width:100%" v-model="cus.promotionExpenseBack"></InputNumber> -->
					<!-- </div>
					<div>{{promotionExpenseBackDiff | initPrice}}</div>
				</div> -->
				<div class="table-row">
					<div style="color:red;width:100%;text-align:left">提交后将取消该子入住单中 属于本支付单的原入账单，按调整金额重新生成入账单</div>
				</div>
			</div>
		</Modal>

	</article>
</template>

<script>
import Moment from "moment";
import Config from "../../config"
import Utils from "../../utils";
import API from "../../api";
import {STORE_KEY} from "../../constants"

export default {
	async created() {
		this.token = Utils.findFromLocalStorage( "vue-token" );
		this.username = Utils.findFromLocalStorage( "vue-username" );
		this.env = Utils.findFromLocalStorage( "env", "dev" );
		// this.analysisUrl = Config[this.env].accountUrl.replace( /(https|http)?:/, '' );
		this.analysisUrl = Config[this.env].accountUrl;
	},
	async mounted() {
		this.$Notice.config( {
			top: 200
		} );
		let sourceTypeResp = ( await API.omsAPI[this.env].php.queryOrderSource() ).data
		if ( sourceTypeResp.retCode ) {
			this.$Notice.error( {
				title: "获取渠道失败",
				desc: sourceTypeResp.msg
			} );
		}
		this.sourceType = sourceTypeResp.retdata;
		this.listPayProjectReport();
		this.querySettleAccountDateList()
	},
	data() {
		let defaultDate = [
			Moment().subtract( 6, 'days' ).format( 'YYYY-MM-DD' ),
			Moment().format( 'YYYY-MM-DD' )
		];
		let defaultDateLimit = [
			Moment().subtract( 7, 'days' ).format( 'YYYY-MM-DD' ),
			Moment().format( 'YYYY-MM-DD' )
		];
		return {
			editPriceModel:{
				display:false,
				importButtonLoading:false,
				uploadData: {
					file: null,
					action: '',
					form: {
						userName: ""
					}
				},
				importModalInfo: {
					filename: ""
				},
			},
			editRecordDisplay:false,
			editRecordFailDisplay:false,  //批量修正失败弹窗
			editRecordFailDisRemark:'',  //批量修正失败原因
			// 结账月份表
			setDate:[],
			chooseDate:false,
			exportBtn: {
				exportFilterResult: false,
				downloadResult: false,
			},
			correction: {
				display: false,
			},
			checkPayInfoId: '',
			defaultFinance: {},
			// reason: '',
			formValidate: {
				reason: ''
			},
			ruleValidate: {
				reason: [
					{type: "string", required: true, message: "修正原因必填"}
				]
			},
			cus: {
				roomPrice: 0,
				ownerBear: 0,
				xbedBear: 0,
				channelCommission: 0,
				otherChannelExpenses: 0,
				ownerPromotionExpense: 0,
				cardRealPrice: 0,
				xbedPromotionExpense: 0,

			},
			financeInfo: {
				orgActualCheckinTime: '',
				orgActualCheckoutTime: '',
				orgPreCheckinTime: '',
				orgPreCheckoutTime: '',
				orgRoomPrice: 0,
				orgOwnerBear: 0,
				orgXbedBear: 0,
				orgShouldPay: 0,
				orgChannelCommission: 0,
				orgOtherChannelExpenses: 0,
				orgOwnerPromotionExpense: 0,
				orgCardRealPrice: 0,
				orgXbedPromotionExpense: 0,
				orgReceivedPrice: 0,
				orgSettlementPrice: 0,
				orgPlatformPrice: 0,
				orgPromotionExpenseBack: 0,
				showCheckinTime:'',
				showCheckoutTime:''
			},
			financeArr: ['', ''],
			currTabName: "projectList",
			columns: {
				projectList: [
					{
						title: "创建时间",
						key: "createDate",
						align: "center",
						width: 200,
						render: ( h, params ) => {
							let createDate = Moment( params.row.createDate ).format( 'YYYY-MM-DD HH:mm:ss' );
							return h( "div", {}, createDate );
						}
					},
					{
						title: "订单号",
						key: "orderNo",
						align: "center",
						width: 220
					},
					{
						title: "房间",
						key: "room",
						width: 150,
						align: "center"
					},
					{
						title: "支付单号",
						key: "payNo",
						width: 150,
						align: "center"
					},
					{
						title: "子入住单号",
						key: "checkinInfoId",
						width: 150,
						align: "center"
					},
					{
						title: "预订渠道",
						key: "checkinInfoSource",
						width: 150,
						align: "center",
						render: ( h, params ) => {
							let source = '';
							for ( let i = 0; i < this.sourceType.length; i++ ) {
								if ( params.row.checkinInfoSource == this.sourceType[i].id ) {
									source = this.sourceType[i].name;
									break;
								}
							}
							return h( "div", {}, source );
						}
					},
					{
						title: "项目",
						key: "project",
						width: 100,
						align: "center"
					},
					{
						title: "金额",
						key: "price",
						width: 100,
						align: "center",
						render: ( h, params ) => {
							return h( "div", {}, params.row.price );
						}
					},
					{
						title: "支付时间",
						key: "payTime",
						width: 200,
						align: "center",
						render: ( h, params ) => {
							let payTime = Moment( params.row.payTime ).format( 'YYYY-MM-DD HH:mm:ss' );
							return h( "div", {}, payTime );
						}
					},
					{
						title: "支付方式",
						key: "payWay",
						width: 180,
						align: "center"
					},
					{
						title: "支付性质",
						key: "payRemark",
						width: 150,
						align: "center"
					},
					{
						title: "支付人",
						key: "payName",
						width: 100,
						align: "center"
					},
					{
						title: "第三方流水号",
						key: "otherNo",
						width: 150,
						align: "center"
					}
				],
				offlineList: [
					{
						title: "支付时间",
						key: "payTime",
						width: 190,
						align: "center",
						render: ( h, params ) => {
							let payTime = Moment( params.row.payTime ).format( 'YYYY-MM-DD HH:mm:ss' );
							return h( "div", {}, payTime );
						}
					},
					{
						title: "支付单号",
						key: "payNo",
						width: 200,
						align: "center"
					},
					{
						title: "订单号",
						key: "orderNo",
						width: 210,
						align: "center"
					},
					{
						title: "预订渠道",
						key: "orderSourceName",
						width: 150,
						align: "center"
					},
					{
						title: "支付方式",
						key: "payWay",
						width: 150,
						align: "center"
					},
					{
						title: "总金额",
						key: "price",
						width: 100,
						align: "center",
						render: ( h, params ) => {
							let price = ( params.row.price / 100 ).toFixed( 2 );
							return h( "div", {}, price );
						}
					},
					{
						title: "确认状态",
						key: "status",
						width: 100,
						align: "center"
					},
					{
						title: "收款渠道",
						key: "receiveWay",
						width: 100,
						align: "center",
						render: ( h, params ) => {
							let source = this.receiveWay[params.row.receiveWay]
							return h( "div", {}, source );
						}
					},
					{
						title: "确认备注",
						key: "remark",
						width: 250,
						align: "center",
						render: ( h, params ) => {
							let remarks = [];
							if ( params.row.remark instanceof Array ) {
								for ( let i = 0; i < params.row.remark.length; i++ ) {
									remarks.push( params.row.remark[i] );
								}
							} else {
								remarks.push( params.row.remark );
							}
							return h( "div", remarks.map( remark => {
								return h( "p", {}, remark )
							} ) );
						}
					},
					{
						title: "操作",
						width: 100,
						align: "center",
						render: ( h, params ) => {
							return h( "div", [
								h(
									"Button",
									{
										props: {
											type: "primary",
											size: "small"
										},
										style: {
											marginRight: "10px",
											visibility:
												params.row.status == "已确认" ? "hidden" : "visible"
										},
										on: {
											click: () => {
												this.confirmStateModalForm.id = params.row.id;
												this.confirmStateModalForm.orderNo = params.row.orderNo;
												this.confirmStateModalForm.payNo = params.row.payNo;
												this.openConfirmModal();
											}
										}
									},
									"确认状态"
								)
							] );
						}
					}
				],
				paymentList: [
					{
						title: "创建时间",
						key: "createTime",
						width: 200,
						align: "center",
						render: ( h, params ) => {
							let createTime = Moment( params.row.createTime ).format( 'YYYY-MM-DD HH:mm:ss' );
							return h( "div", {}, createTime );
						}
					},
					{
						title: "结账月份",
						key: "settleDate",
						align: "center",
						width: 150,
						render: ( h, params ) => {
							let settleDate = params.row.settleDate ? Moment( params.row.settleDate ).format( 'YYYY-MM' ) : '-';
							return h( "div", {}, settleDate );
						}
					},
					{
						title: "订单号",
						key: "orderNo",
						width: 250,
						align: "center"
					},
					{
						title: "支付单号",
						key: "payNo",
						width: 200,
						align: "center"
					},
					{
						title: "预订渠道",
						key: "orderSourceName",
						width: 150,
						align: "center"
					},
					{
						title: "OTA单号",
						key: "otaNo",
						width: 150,
						align: "center"
					},
					{
						title: "支付方式",
						key: "payTypeName",
						width: 150,
						align: "center"
					},
					{
						title: "总金额",
						key: "totalPrice",
						width: 100,
						align: "center",
						render: ( h, params ) => {
							let totalPrice = ( params.row.totalPrice / 100 ).toFixed( 2 );
							return h( "div", {}, totalPrice );
						}
					},
					{
						title: "支付单实收",
						key: "payPrice",
						width: 110,
						align: "center",
						render: ( h, params ) => {
							let payPrice = ( params.row.payPrice / 100 ).toFixed( 2 );
							return h( "div", {}, payPrice );
						}
					},
					{
						title: "xbed实收",
						key: "payPrice",
						width: 110,
						align: "center",
						render: ( h, params ) => {
							let receivedPrice = ( params.row.receivedPrice / 100 ).toFixed( 2 );
							return h( "div", {}, receivedPrice );
						}
					},
					{
						title: "退款金额",
						key: "refundPrice",
						width: 100,
						align: "center",
						render: ( h, params ) => {
							let refundPrice = ( params.row.refundPrice / 100 ).toFixed( 2 );
							return h( "div", {}, refundPrice );
						}
					},
					{
						title: "第三方流水号",
						key: "otherNo",
						width: 150,
						align: "center"
					},
					{
						title: "结算单号",
						key: "settlementNo",
						width: 150,
						align: "center"
					},
					{
						title: "对账状态",
						key: "accountState",
						width: 100,
						align: "center"
					},
					{
						title: "收款状态",
						key: "receiptState",
						width: 100,
						align: "center"
					},
					{
						title: "操作备注",
						key: "remark",
						width: 250,
						align: "center",
						render: ( h, params ) => {
							let remarks = [];
							if ( params.row.remark instanceof Array ) {
								for ( let i = 0; i < params.row.remark.length; i++ ) {
									remarks.push( params.row.remark[i] );
								}
							} else {
								remarks.push( params.row.remark );
							}
							return h( "div", remarks.map( remark => {
								return h( "p", {}, remark )
							} ) );
						}
					},
					{
						title: "操作",
						width: 200,
						align: "center",
						render: ( h, params ) => {
							return h( "div", [
								h(
									"Button",
									{
										props: {
											type: "primary",
											size: "small"
										},
										style: {
											marginRight: "10px"
										},
										on: {
											click: () => {
												this.openDetailModal( params.row.id );
											}
										}
									},
									"修正/状态/明细"
								)
							] );
						}
					}
				]
			},
			projectType: ["全部", "房费", "押金", "增值服务", "旧数据迁移", "超时支付成功"],
			receiveWay: ['', '微信', '支付宝', '银联', '现金'],
			payMethodType: [
				"全部",
				"OTA直连",
				"微信",
				"银联",
				"OMS代客支付",
				"支付宝",
				"OMS自动支付",
				"银联（线下）",
				"支付宝（线下）",
				"微信（线下）",
				"现金（线下）",
				"其他（线下）",
				"小程序"
			],
			sourceType: [],
			projectList: {
				tabName: "projectList",
				count: 0, //记录总数
				pageCount: 0, //页面总数
				page: 1, // 第几页
				pageSize: 10, // 每页数量
				loading: false,
				data: []
			},
			offlineList: {
				tabName: "offlineList",
				count: 0, //记录总数
				pageCount: 0, //页面总数
				page: 1, // 第几页
				pageSize: 10, // 每页数量
				loading: false,
				data: []
			},
			paymentList: {
				tabName: "paymentList",
				count: 0,
				pageCount: 0,
				page: 1,
				pageSize: 10,
				loading: false,
				data: []
			},
			projectForm: {
				createDate: defaultDate,
				payWay: 0,
				orderNo: "",
				project: 0,
				payName: "",
				payNo: "",
				source: "S00"
			},
			offlineForm: {
				payTime: defaultDate,
				orderNo: "",
				orderSource: "S00",
				payNo: "",
				payWay: 0,
				status: "S00"
			},
			paymentForm: {
				createDate:defaultDateLimit,
				orderNo: "",
				payNo: "",
				orderSource: "S00",
				otaNo: "",
				payTime: "",
				settlementNo: "",
				payType: 0,
				accountState: "S00",
				receiptState: "S00",
				settleDateMonth:'',
			},
			stateDetailData: {
				baseInfo: {
					accountState: "",
					payNo: "",
					payPrice: 0,
					payTime: "",
					payTypeName: "",
					price: "",
					receiptState: "",
					refundAmount: "",
					remark: []
				},
				relateChildOrder: [],
				account: [],
				receipt: [],
				showButton: false,
				tableLoading: true
			},
			stateDetailColumns: {
				relateChildOrder: [
					{
						title: '订单号',
						key: 'orderNo',
						align: 'center',
						width: 220
					},
					{
						title: '子入住单号',
						key: 'checkinInfoId',
						align: 'center',
						width: 200
					},
					{
						title: '总支付单实收',
						key: 'payReceivedPrice',
						align: 'center',
						width: 180,
						render: ( h, params ) => {
							return h( "div", {}, ( params.row.payReceivedPrice / 100 ).toFixed( 2 ) );
						}
					},
					{
						title: 'xbed实收',
						key: 'xbedReceivedPrice',
						align: 'center',
						width: 180,
						render: ( h, params ) => {
							return h( "div", {}, ( params.row.xbedReceivedPrice / 100 ).toFixed( 2 ) );
						}
					},
					{
						title: '操作',
						align: 'center',
						width: 200,
						render: ( h, params ) => {
							return h( 'Button', {
								props: {
									type: "primary",
									size: "small",
									disabled: !( this.stateDetailData.baseInfo.accountState === '未对账' || this.stateDetailData.baseInfo.accountState === '异常' )
								},
								on: {
									click: () => {
										this.getFinanceInfo( params.row.checkinInfoId )
									}
								}
							}, '修正' )
						}
					},
				],
				account: [
					{
						title: "ID",
						key: "id",
						align: "center",
						width: 200
					},
					{
						title: "结算单号",
						key: "settlementNo",
						align: "center",
						width: 200
					},
					{
						title: "xbed实收",
						key: "payPrice",
						align: "center",
						width: 200,
						render: ( h, params ) => {
							let payPrice = ( params.row.payPrice / 100 ).toFixed( 2 );
							return h( "div", {}, payPrice );
						}
					},
					{
						title: "结算金额",
						key: "settlementPrice",
						align: "center",
						width: 200,
						render: ( h, params ) => {
							let settlementPrice = ( params.row.settlementPrice / 100 ).toFixed( 2 );
							return h( "div", {}, settlementPrice );
						}
					},
					{
						title: "处理结果",
						key: "state",
						align: "center",
						width: 200
					},
					{
						title: "导入时间",
						key: "importTime",
						align: "center",
						width: 200,
						render: ( h, params ) => {
							let importTime = Moment( params.row.importTime ).format( 'YYYY-MM-DD HH:mm:ss' );
							return h( "div", {}, importTime );
						}
					},
					{
						title: "操作人",
						key: "createName",
						align: "center",
						width: 200
					}
				],
				receipt: [
					{
						title: "ID",
						key: "id",
						align: "center",
						width: 200
					},
					{
						title: "结算单号",
						key: "settlementNo",
						align: "center",
						width: 200
					},
					{
						title: "总xbed实收",
						key: "payPrice",
						align: "center",
						width: 200,
						render: ( h, params ) => {
							let payPrice = ( params.row.payPrice / 100 ).toFixed( 2 );
							return h( "div", {}, payPrice );
						}
					},
					{
						title: "收款金额",
						key: "receivedPrice",
						align: "center",
						width: 200,
						render: ( h, params ) => {
							let receivedPrice = ( params.row.receivedPrice / 100 ).toFixed( 2 );
							return h( "div", {}, receivedPrice );
						}
					},
					{
						title: "处理结果",
						key: "state",
						align: "center",
						width: 200
					},
					{
						title: "导入时间",
						key: "importTime",
						align: "center",
						width: 200,
						render: ( h, params ) => {
							let importTime = Moment( params.row.importTime ).format( 'YYYY-MM-DD HH:mm:ss' );
							return h( "div", {}, importTime );
						}
					},
					{
						title: "操作人",
						key: "createName",
						align: "center",
						width: 200
					}
				]
			},
			// 导入对账/收款单 modal
			importModalDisplay: false,
			importmodalButtonLoading: false,
			importModalInfo: {
				date:'',
				title: "",
				filename: ""
			},
			importResultColumn: [
				{
					title: "类型",
					key: "type",
					align: "center",
					width: 200,
					render: ( h, params ) => {
						let type = params.row.type == 1 ? "对账单" : "收款单";
						return h( "div", {}, type );
					}
				},
				{
					title: "导入数据量",
					key: "importNumber",
					align: "center",
					width: 200
				},
				{
					title: "无效数据量",
					key: "invalidNumber",
					align: "center",
					width: 200
				},
				{
					title: "匹配数据量",
					key: "matchedNumber",
					align: "center",
					width: 200
				},
				{
					title: "匹配成功量",
					key: "matchSuccessNumber",
					align: "center",
					width: 200
				},
				{
					title: "匹配异常量",
					key: "matchFailedNumber",
					align: "center",
					width: 200
				}
			],
			importResultData: [],
			uploadData: {
				file: null,
				action: '',
				form: {userName: ""}
			},
			resultModalDisplay: false,
			// 状态/明细 modal
			detailModalDisplay: false,
			editStateModalDisplay: false,
			editStateModalForm: {
				title: "",
				action: "",
				id: 0,
				type: 1,
				state: 1,
				remark: "",
				setDate:'',
			},
			// 确认状态 modal
			confirmStateModalDisplay: false,
			confirmStateModalForm: {
				id: 0,
				state: "",
				receiveWay: "",
				remark: "",
				payNo: "",
				orderNo: "",
				setDate:""
			},
			confirmStateValidate: {
				state: [
					{
						required: true,
						type: "number",
						message: "请选择状态！",
						trigger: "change"
					}
				],
				setDate: [
					{
						required: true,
						type: "string",
						message: "请选择结账月份！",
						trigger: "change"
					}
				],
				receiveWay: [
					{required: true, message: "请选择收款渠道！", type: 'number', trigger: "change"}
				],
				remark: [
					{required: true, message: "请填写备注！", trigger: "blur"},
					{type: 'string', max: 512, message: '备注不能超过512字', trigger: 'blur'}
				]
			},
			// 下载导入模板 modal
			downloadTemplateModalDisplay: false,
		};
	},
	methods: {
		selectChange(e){
			if(e === 3) {
				this.confirmStateValidate = Object.assign({},this.confirmStateValidate,{receiveWay:[{required:false}]})
				this.confirmStateModalForm.receiveWay = ""
			} else {
				this.confirmStateValidate =  Object.assign({},this.confirmStateValidate,{receiveWay:[{required:true,message: "请选择收款渠道！"}]})
			}
		},
		changeDate( dateRange, formName, datePicker ) {
			if ( !dateRange[0] ) {
				this[formName][datePicker] = [];
			} else {
				let tranferDate = []
				for ( let i = 0; i < dateRange.length; i++ ) {
					let date = Moment( dateRange[i] ).format( 'YYYY-MM-DD' )
					tranferDate.push( date );
				}
				this[formName][datePicker] = tranferDate;
			}
		},
		changeDateLimit( dateRange, formName, datePicker ) {
			if((Moment( dateRange[1] ) - Moment( dateRange[0] ))/(24*60*60*1000)+1 >= 91){
				this.$Notice.error( {
					title: "创建日期",
					desc: "日期间隔不可超过91天！"
				} );
				this[formName][datePicker] = [
					Moment().subtract( 7, 'days' ).format( 'YYYY-MM-DD' ),
					Moment().format( 'YYYY-MM-DD' )
				]
				return
			}

			let tranferDate = []
			for ( let i = 0; i < dateRange.length; i++ ) {
				let date = Moment( dateRange[i] ).format( 'YYYY-MM-DD' )
				tranferDate.push( date );
			}
			this[formName][datePicker] = tranferDate;
		},
		

		toggleTab( tabName ) {
			this.currTabName = tabName;
			this[tabName].page = 1;
			this.queryReport();
		},
		changePage( pageIndex ) {
			this[this.currTabName].page = pageIndex;
			this.queryReport();
		},
		changePageSize( pageSize ) {
			this[this.currTabName].page = 1;
			this[this.currTabName].pageSize = pageSize;
			this.queryReport();
		},
		queryReport() {
			if ( this.currTabName == "projectList" ) {
				this.listPayProjectReport();
			} else if ( this.currTabName == "offlineList" ) {
				this.listOfflinePayment();
			} else if ( this.currTabName == "paymentList" ) {
				this.listPayInfoReport();
			}
		},
		// 支付单项目列表
		queryListPayProjectReport() {
			if ( !this.checkPayProjectAccess() ) {
				return;
			}
			this.projectList.page = 1;
			this.listPayProjectReport();
		},
		async listPayProjectReport() {
			this.projectList.loading = true;
			let resp = ( await this.sendListPayProjectReport(
				this.projectList,
				this.token,
				this.env
			) ).data;
			if ( resp.retCode ) {
				this.$Notice.error( {
					title: "查询失败",
					desc: resp.msg
				} );
			}
			this.projectList.data = resp.result;
			this.projectList.count = resp.count;
			this.projectList.pageCount = resp.pageCount;
			this.projectList.loading = false;
		},
		sendListPayProjectReport( projectList, token, env ) {
			let startDate = Moment( this.projectForm.createDate[0] ).format( 'YYYY-MM-DD' );
			let endDate = Moment( this.projectForm.createDate[1] ).format( 'YYYY-MM-DD' );
			let params = {
				page: projectList.page,
				size: projectList.pageSize,
				startDate: startDate,
				endDate: endDate
			};
			this.projectForm.payName ? params.payName = this.projectForm.payName : '';
			this.projectForm.orderNo ? params.orderNo = this.projectForm.orderNo : '';
			this.projectForm.payNo ? params.payNo = this.projectForm.payNo : '';
			this.projectForm.payWay !== 0 ? params.payWay = this.projectForm.payWay : '';
			this.projectForm.source !== "S00" ? params.source = this.projectForm.source : '';
			this.projectForm.project !== 0 ? params.project = this.projectForm.project : '';
			return API.omsAPI[env].order.queryPayList( params, token );
		},
		checkPayProjectAccess() {
			if ( this.projectForm.createDate.join( '' ).length == 0 ) {
				this.$Notice.error( {
					title: "查询失败",
					desc: "创建日期不能为空"
				} );
				return false;
			}
			return true;
		},
		// 导出支付单项目列表
		exportListPayProjectReport() {
			if ( !this.checkHasPermission( 'excel_payInfoList' ) ) {
				return;
			}
			let params = {
				size: 100000000,
				page: 1,
				startDate: Moment( this.projectForm.createDate[0] ).format( 'YYYY-MM-DD' ),
				endDate: Moment( this.projectForm.createDate[1] ).format( 'YYYY-MM-DD' )
			}
			this.projectForm.payName ? params.payName = this.projectForm.payName : '';
			this.projectForm.orderNo ? params.orderNo = this.projectForm.orderNo : '';
			this.projectForm.payNo ? params.payNo = this.projectForm.payNo : '';
			this.projectForm.payWay !== 0 ? params.payWay = this.projectForm.payWay : '';
			this.projectForm.source !== "S00" ? params.source = this.projectForm.source : '';
			this.projectForm.project !== 0 ? params.project = this.projectForm.project : '';

			let url = `${ Config[this.env].phpUrl }Interface/index.php/Home/Reserve/queryPayListByDateExcelData?json_data=${ JSON.stringify( params ) }`;
			// window.open( url );
			Utils.exportExcelWeighting( url, this.token, this.$Notice.error,'','')
		},
		// 线下支付确认收款表
		queryListOfflinePayment() {
			if ( !this.checkOfflinePaymentAccess() ) {
				return;
			}
			this.offlineList.page = 1;
			this.listOfflinePayment();
		},
		async listOfflinePayment() {
			this.offlineList.loading = true;
			let resp = ( await this.sendListOfflinePayment(
				this.offlineList,
				this.token,
				this.env
			) ).data;
			if ( resp.retCode ) {
				this.$Notice.error( {
					title: "查询失败",
					desc: resp.msg
				} );
			}
			this.offlineList.data = resp.result;
			this.offlineList.count = resp.count;
			this.offlineList.pageCount = resp.pageCount;
			this.offlineList.loading = false;
		},
		sendListOfflinePayment( offlineList, token, env ) {
			let startDate = Moment( this.offlineForm.payTime[0] ).format( 'YYYY-MM-DD' );
			let endDate = Moment( this.offlineForm.payTime[1] ).format( 'YYYY-MM-DD' );
			let params = {
				page: offlineList.page,
				size: offlineList.pageSize,
				startDate: startDate,
				endDate: endDate
			};
			this.offlineForm.orderNo ? params.orderNo = this.offlineForm.orderNo : '';
			this.offlineForm.payNo ? params.payNo = this.offlineForm.payNo : '';
			this.offlineForm.orderSource !== "S00" ? params.orderSource = this.offlineForm.orderSource : '';
			this.offlineForm.payWay !== 0 ? params.payWay = this.offlineForm.payWay : '';
			this.offlineForm.status !== "S00" ? params.status = this.offlineForm.status : '';
			return API.omsAPI[env].order.queryListOfflinePayment( params, token );
		},
		checkOfflinePaymentAccess() {
			if ( this.offlineForm.payTime.length == 0 ) {
				this.$Notice.error( {
					title: "查询失败",
					desc: "支付日期不能为空"
				} );
				return false;
			}
			return true;
		},
		// 支付单列表
		queryListPayInfoReport() {
			if ( !this.checkPayInfoAccess() ) {
				return;
			}
			this.paymentList.page = 1;
			this.listPayInfoReport();
		},
		async listPayInfoReport() {
			this.paymentList.loading = true;
			let resp = ( await this.sendListPayInfoReport(
				this.paymentList,
				this.token,
				this.env
			) ).data;
			if ( resp.retCode ) {
				this.$Notice.error( {
					title: "查询失败",
					desc: resp.msg
				} );
			}
			this.paymentList.data = resp.result;
			this.paymentList.count = resp.count;
			this.paymentList.pageCount = resp.pageCount;
			this.paymentList.loading = false;
		},
		sendListPayInfoReport( paymentList, token, env ) {
			let createstartDate = Moment( this.paymentForm.createDate[0] ).format( 'YYYY-MM-DD' );
			let createendDate = Moment( this.paymentForm.createDate[1] ).format( 'YYYY-MM-DD' );
			let params = {
				page: paymentList.page,
				size: paymentList.pageSize,
				createdAtBegin: createstartDate,
				createdAtEnd: createendDate,
			};
			this.paymentForm.payTime[0] ? params.startDate = Moment(this.paymentForm.payTime[0]).format( 'YYYY-MM-DD' ) : "";
			this.paymentForm.payTime[1] ? params.endDate = Moment(this.paymentForm.payTime[1]).format( 'YYYY-MM-DD' ) : "";

			this.paymentForm.accountState !== "S00" ? params.accountState = this.paymentForm.accountState : '';
			this.paymentForm.orderSource !== "S00" ? params.orderSource = this.paymentForm.orderSource : '';
			this.paymentForm.receiptState !== "S00" ? params.receiptState = this.paymentForm.receiptState : '';
			this.paymentForm.settleDateMonth ? params.settleDate = Moment( this.paymentForm.settleDateMonth ).format( "YYYY-MM" ) : '';  //结账月份
			this.paymentForm.orderNo ? params.orderNo = this.paymentForm.orderNo : '';
			this.paymentForm.payNo ? params.payNo = this.paymentForm.payNo : '';
			this.paymentForm.payType !== 0 ? params.payType = this.paymentForm.payType : '';
			this.paymentForm.otaNo ? params.otaNo = this.paymentForm.otaNo : '';
			this.paymentForm.settlementNo ? params.settlementNo = this.paymentForm.settlementNo : '';

			return API.omsAPI[env].order.queryListPayInfoReport( params, token );
		},
		checkPayInfoAccess() {
			if ( this.paymentForm.createDate.length == 0 ) {
				this.$Notice.error( {
					title: "查询失败",
					desc: "创建日期不能为空"
				} );
				return false;
			}
			return true;
		},
		// 确认状态 modal
		openConfirmModal() {
			if ( !this.checkHasPermission( 'oms_analysis_check_confirmPayState' ) ) {
				return;
			}
			this.confirmStateModalDisplay = true;
		},
		async prepareConfirmStatus() {
			let validResult = true;
			this.$refs.confirmStateModalForm.validate( valid => {
				validResult = valid
			} );
			if ( !validResult ) {
				this.$refs.confirmStateModal.buttonLoading = false;
				return;
			}
			if ( this.confirmStateModalForm.state !== 3 && !this.confirmStateModalForm.receiveWay ) {
				this.$Notice.error( {
					title: "确认状态失败",
					desc: "请选择收款渠道"
				} );
				this.$refs.confirmStateModal.buttonLoading = false;
				return;
			}

			let resp = ( await this.updateConfirmPayState( this.confirmStateModalForm, this.token, this.env ) ).data;

			if ( resp.retCode ) {
				this.$Notice.error( {
					title: "修改状态失败",
					desc: resp.msg
				} );
				this.$refs.confirmStateModal.buttonLoading = false;
			} else {
				this.$Notice.success( {
					title: "修改状态成功"
				});
				this.resetConfirmStateModalForm();
				this.refreshTable();
				this.listPayInfoReport();
				this.confirmStateModalDisplay = false;
			}
		},
		updateConfirmPayState( confirmStateModalForm, token, env ) {
			return API.omsAPI[env].order.updateConfirmPayState(
				confirmStateModalForm.id,
				this.username,
				confirmStateModalForm.receiveWay,
				confirmStateModalForm.remark,
				confirmStateModalForm.state,
				confirmStateModalForm.orderNo,
				confirmStateModalForm.payNo,
				confirmStateModalForm.setDate,
				token
			)
		},
		cancelConfirmState() {
			this.resetConfirmStateModalForm();
		},
		resetConfirmStateModalForm() {
			this.confirmStateModalForm = {
				id: 0,
				state: "",
				receiveWay: "",
				remark: "",
				setDate:""
			};
		},
		// 状态/明细 modal
		openDetailModal( id = this.checkPayInfoId ) {
			this.checkPayInfoId = id;
			this.initDetailDate();
			this.queryListPayInfoDetailInfo( id );
			this.detailModalDisplay = true;
		},
		initDetailDate() {
			this.stateDetailData = {
				baseInfo: {
					accountState: "-",
					payNo: "-",
					payPrice: "-",
					payTime: "-",
					payTypeName: "-",
					price: "-",
					receiptState: "-",
					refundAmount: "-",
					remark: ['-']
				},
				relateChildOrder: [],
				account: [],
				receipt: [],
				showButton: false,
				tableLoading: true
			}
		},
		async queryListPayInfoDetailInfo( id ) {
			let resp = ( await API.omsAPI[this.env].order.queryListPayInfoDetailInfo( id, this.token ) ).data;

			if ( resp.retCode ) {
				this.$Notice.error( {
					title: "查询失败",
					desc: resp.msg
				} );
			}

			this.stateDetailData.baseInfo = resp.baseInfo;
			this.stateDetailData.baseInfo.id = id;
			this.stateDetailData.baseInfo.payTime = Moment( this.stateDetailData.baseInfo.payTime ).format( 'YYYY-MM-DD HH:mm:ss' )
			this.stateDetailData.account = resp.account;
			this.stateDetailData.receipt = resp.receipt;
			this.stateDetailData.relateChildOrder = resp.checkPayRelation;
			this.stateDetailData.baseInfo.showButton = true;
			this.stateDetailData.tableLoading = false;
		},
		// 结账月份列表
		async querySettleAccountDateList(){
			let params = {}
			let resp = (await API.omsAPI[this.env].order.settleAccountDateList(params, this.token)).data;
				if (resp.retCode ) {
				this.$Notice.error( {
					title: '获取结账月份数据异常',
					desc: resp.msg
				})
				return
			}
			this.setDate = resp
		},
		// 修改对账收款状态 modal
		openEditStateModal( action, state ) {
			if ( !this.checkHasPermission( 'oms_analysis_check_updatePayInfoCheckState' ) ) {
				return;
			}

			if ( action === "account" ) {
				this.editStateModalForm.title = "修改对账状态";
				this.editStateModalForm.type = 1;
				this.editStateModalForm.state = ['', '未对账', '已对账', '异常'].indexOf( state );
			} else if ( action === "receipt" ) {
				this.editStateModalForm.title = "修改收款状态";
				this.editStateModalForm.type = 2;
				this.editStateModalForm.state = ['', '未收款', '已收款', '异常'].indexOf( state );
			}
			this.editStateModalForm.id = this.stateDetailData.baseInfo.id;
			this.editStateModalDisplay = true;
		},
		async prepareEditState() {
			if (this.editStateModalForm.type === 1 && this.editStateModalForm.state === 2) {
				if (!this.editStateModalForm.setDate) {
					this.$Notice.error( {
						title: "请先选择结账月份",
					});
					this.$refs.editStateModal.buttonLoading = false;
					return;
				}
			}
			if ( this.editStateModalForm.remark.length == 0 ) {
				this.$Notice.error( {
					title: "修改失败",
					desc: "备注不能为空"
				} );
				this.$refs.editStateModal.buttonLoading = false;
				return;
			}
			let resp = ( await this.updatePayInfoCheckState( this.token, this.env ) ).data;
			if ( resp.retCode ) {
				this.$Notice.error( {
					title: "修改状态失败",
					desc: resp.msg
				} );
				this.$refs.editStateModal.buttonLoading = false;
			} else {
				this.$Notice.success( {
					title: "修改状态成功"
				} );
				this.queryListPayInfoDetailInfo( this.stateDetailData.baseInfo.id );

				this.resetEditStateModalForm();
				this.listPayInfoReport();
				this.editStateModalDisplay = false;
			}
		},
		updatePayInfoCheckState( token, env ) { 
			return API.omsAPI[env].order.updatePayInfoCheckState(
				this.editStateModalForm.id,
				this.username,
				this.editStateModalForm.remark,
				this.editStateModalForm.state,
				this.editStateModalForm.type,
				this.editStateModalForm.type === 1 && this.editStateModalForm.state === 2 ? this.editStateModalForm.setDate : '',
				token
			);
		},
		cancelEditState() {
			this.resetEditStateModalForm();
		},
		resetEditStateModalForm() {
			this.editStateModalForm = {
				title: "",
				action: "",
				id: this.editStateModalForm.id,
				type: 1,
				state: 1,
				remark: "",
				setDate:''
			};
		},
		exportFilterResult() {
			if ( !this.checkHasPermission( 'check_exportPayInfoReport' ) ) {
				return;
			}
			if ( this.paymentForm.createDate.length == 0 ) {
				this.$Notice.error( {
					title: "导出失败",
					desc: "创建日期不能为空"
				} );
				return;
			}
			let createstartDate = Moment( this.paymentForm.createDate[0] ).format( 'YYYY-MM-DD' );
			let createendDate = Moment( this.paymentForm.createDate[1] ).format( 'YYYY-MM-DD' );
			let startDate = this.paymentForm.payTime[0] ? Moment(this.paymentForm.payTime[0]).format( 'YYYY-MM-DD' ) : "";
			let endDate = this.paymentForm.payTime[1] ? Moment(this.paymentForm.payTime[1]).format( 'YYYY-MM-DD' ) : "";

			let url = `${ Config[this.env].accountUrl }check/exportPayInfoReport` +
				"?startDate=" + startDate +
				"&endDate=" + endDate +
				"&createdAtBegin=" + createstartDate +
				"&createdAtEnd=" + createendDate +  
				"&orderNo=" + this.paymentForm.orderNo +
				"&orderSource=" + ( this.paymentForm.orderSource == "S00" ? '' : this.paymentForm.orderSource ) +
				"&otaNo=" + this.paymentForm.otaNo +
				"&payNo=" + this.paymentForm.payNo +
				"&payType=" + ( this.paymentForm.payType == 0 ? '' : this.paymentForm.payType ) +
				"&settlementNo=" + this.paymentForm.settlementNo +
				"&accountState=" + ( this.paymentForm.accountState == "S00" ? '' : this.paymentForm.accountState ) +
				"&settleDate=" + ( this.paymentForm.settleDateMonth ? Moment(this.paymentForm.settleDateMonth).format( 'YYYY-MM' ) : '' ) +
				"&receiptState=" + ( this.paymentForm.receiptState == "S00" ? '' : this.paymentForm.receiptState );

			// window.open(url ,"_blank");
			Utils.exportExcelWeighting( url, this.token, this.$Notice.error, this.exportBtn, "exportFilterResult")

		},
		//=========================================== 批量修正金额======================================
		openEditPriceModel(){
			if ( !this.checkHasPermission( 'check_adjustmentCheckinInfoBatch' ) ) {
				return;
			}
			this.editPriceModel.importButtonLoading = false;
			this.editPriceModel.uploadData = {
				file: null,
				form: {userName: this.username}
			};
			this.editPriceModel.importModalInfo = {
				filename: ""
			};
			this.editPriceModel.uploadData.action = `${this.analysisUrl }check/adjustmentCheckinInfoBatch`;
      this.editPriceModel.display = true
		},
		// 点击下载
		openEditPriceDownLoad(){
			if ( !this.checkHasPermission( 'check_downlaodCorrectionTemplate' ) ) {
				return;
			}
			let url = 'https://public-test.xbed.com.cn/%E6%89%B9%E9%87%8F%E4%BF%AE%E6%AD%A3%E6%A8%A1%E6%9D%BF.xlsx'
			window.open( url, "_blank" );
		},
		editBeforeUpload(file){
      let regResult = /\.(?:xlsx|xls)$/.test( file.name );
			if ( !regResult ) {
				this.$Notice.error( {
					title: "导入失败",
					desc: "请导入xlsx/xls格式的excel文件"
				} );
			} else {
				this.editPriceModel.uploadData.file = file;
				this.editPriceModel.importModalInfo.filename = file.name;
			}
			return false;
		},
		editprepareImport(){
			if (!this.editPriceModel.uploadData.file) {
				this.$Notice.error( {
					title: "导入失败",
					desc: "请导入xlsx/xls格式的excel文件"
				});
				this.editPriceModel.importButtonLoading = false
				return;
			}
			this.editPriceModel.importButtonLoading = true;
			this.editPriceModel.uploadData.form.userName = this.username;
			this.$refs.files.post(this.editPriceModel.uploadData.file );
		},
		editUploadSuccess(resp){
			this.editPriceModel.importButtonLoading = false
			if (resp.retCode != 21020000 ) {
				// this.$Notice.error({
				// 	title: "导入失败",
				// 	desc: resp.msg
				// });
				this.editRecordFailDisRemark = resp.msg
				this.editPriceModel.display = false;
				this.editRecordFailDisplay = true
				return
			}
			this.$Notice.success({
				title: "导入成功",
				desc: resp.msg
			});
			this.editPriceModel.display = false;
      this.editRecordDisplay = true
		},
		editUploadError( e, error ){
			this.editPriceModel.importButtonLoading = false
			let msg = "请稍候再试";
			if ( error.msg ) {
				msg = error.msg;
			}
			this.$Notice.error( {
				title: "导入失败",
				desc: msg
			});
		},
		editResetImport(){
      this.editPriceModel.uploadData = {
				file: null,
				action: `${ this.analysisUrl }check/adjustmentCheckinInfoBatch`,
				form: {userName: this.username}
			};
			this.editPriceModel.importModalInfo = {
				filename: ""
			};
			this.editPriceModel.display = false;
		},
		// 导入记录提示
		editCancel(){
      this.editRecordDisplay = false
		},
		editFailRecord(){
      this.editRecordFailDisplay = false
		},
		editRecord(){
			if ( !this.checkHasPermission( 'oms_account_check_batchAdjustmentRecordList' ) ) {
				return;
			}
			this.editRecordDisplay = false
			// 跳转页面原页面因弹窗问题无法滚动，故添加定时器
			setTimeout(()=>{
        if (this.editRecordDisplay === false) {
					if ( this.$router ) {   //跳转至批量修正金额导入记录
						this.$router.push( {path: "/app/order/import-record"} );  
					} else {
						window.open (`#/Order/Reserve/importRecord`)
					}
				}
      },500)
		},
		// ================================导入对账/收款单 modal================================
		openImportModal( action ) {
			if ( action === "account" ) {
				if ( !this.checkHasPermission( 'check_importAccount' )) {
					return;
				}
				this.chooseDate = true
				this.importModalInfo.title = "导入对账单";
				this.uploadData.action = `${ this.analysisUrl }check/importAccount`;
			} else if ( action === "receipt" ) {
				if (!this.checkHasPermission( 'check_importReceipt' )) {
					return;
				}
				this.chooseDate = false
				this.importModalInfo.title = "导入收款单";
				this.uploadData.action = `${ this.analysisUrl }check/importReceipt`;
			}
			this.importModalDisplay = true;
		},
		beforeUpload( file ) {
			let regResult = /\.(?:xlsx)$/.test( file.name );
			if ( !regResult ) {
				this.$Notice.error({
					title: "导入失败",
					desc: "请导入xlsx格式的excel文件"
				});
			} else {
				this.uploadData.file = file;
				this.importModalInfo.filename = file.name;
			}
			return false;
		},
		async prepareImport() {
			if (this.chooseDate) {
				if (!this.importModalInfo.date) {
					this.$Notice.error( {
						title: "请先选择结账月份",
					} );
				this.importmodalButtonLoading = false;
				return;
        }
			}
			if ( !this.uploadData.file ) {
				this.$Notice.error( {
					title: "导入失败",
					desc: "请导入xlsx格式的excel文件"
				} );
				this.importmodalButtonLoading = false;
				return;
			}
			if (this.chooseDate) {
				this.uploadData.form.settleDate = this.importModalInfo.date;
			}
			this.importmodalButtonLoading = true;
			this.uploadData.form.userName = this.username;
			this.$refs.file.post( this.uploadData.file );
		},
		uploadSuccess( resp ) {
			this.importmodalButtonLoading = false;
			if ( !resp.data ) {
				this.$Notice.error( {
					title: "导入失败",
					desc: resp.msg
				} );
				return;
			}

			this.importResultData = [resp.data];
			this.resetImport();
			this.importModalDisplay = false;
			this.resultModalDisplay = true;
		},
		uploadError( e, error ) {
			this.importmodalButtonLoading = false;
			let msg = "请稍候再试";
			if ( error.msg ) {
				msg = error.msg;
			}
			this.$Notice.error( {
				title: "导入失败",
				desc: msg
			} );
		},
		resetImport() {
			this.uploadData = {
				file: null,
				action: `${ this.analysisUrl }check/importAccount`,
				form: {
					userName: this.username,
					settleDate:''
				}
			};
			this.importModalInfo = {
				title: "",
				filename: ""
			};
			this.importModalDisplay = false;
		},
		downloadResult() {
			if ( !this.checkHasPermission( 'check_downloadSingleCheckResult' ) ) {
				return;
			}
			let url = `${ Config[this.env].accountUrl }check/downloadSingleCheckResult` + "?id=" + this.importResultData[0].id + "&type=" + this.importResultData[0].type

			// window.open(url ,"_blank");
			Utils.exportExcelWeighting( url, this.token, this.$Notice.error, this.exportBtn, "downloadResult")

		},
		// 下载导入模板
		openDownloadTemplateModal() {
			if ( !this.checkHasPermission( 'check_downloadTemplate' )) {
				return;
			}
			this.downloadTemplateModalDisplay = true;
		},
		downloadTemplate( type ) {
			let url = `https://public-test.xbed.com.cn/${ type == 1 ? '%E5%AF%B9%E8%B4%A6%E6%A8%A1%E6%9D%BF' : '%E6%94%B6%E6%AC%BE%E6%A8%A1%E6%9D%BF' }.xlsx`;
			window.open( url, "_blank" );
		},
		// 查看导入记录
		viewImportRecords() {
			if ( !this.checkHasPermission( 'oms_analysis_check_listCheckResult' ) ) {
				return;
			}
			if ( this.$router ) {
				this.$router.push( {path: "/app/report/importRecords"} );
			} else {
				window.open( `#/Order/Reserve/listCheckResult` );
			}
		},
		checkHasPermission( name ) {
			if ( !Utils.hasPermission( name ) ) {
				this.$Notice.error( {
					title: Utils.getFromStore( STORE_KEY.STORE_KEY_NOT_PERMISSION_TIPS )
				} );

				return false;
			}
			return true;
		},
		resetTabPane() {
			this.projectList = {
				tabName: "projectList",
				count: 0, //记录总数
				pageCount: 0, //页面总数
				page: 1, // 第几页
				pageSize: 10, // 每页数量
				loading: false,
				data: []
			};
			this.offlineList = {
				tabName: "offlineList",
				count: 0, //记录总数
				pageCount: 0, //页面总数
				page: 1, // 第几页
				pageSize: 10, // 每页数量
				loading: false,
				data: []
			};
			this.paymentList = {
				tabName: "paymentList",
				count: 0,
				pageCount: 0,
				page: 1,
				pageSize: 10,
				loading: false,
				data: []
			};
		},
		refreshTable() {
			this.resetTabPane();
			this.queryReport();
		},
		/**
		 * 子入住单联动查询账务（账务模块
		 * @param payNo
		 * @param checkinInfoId
		 */
		initModelDate() {
			this.cus = {
				roomPrice: 0,
				ownerBear: 0,
				xbedBear: 0,
				channelCommission: 0,
				otherChannelExpenses: 0,
				ownerPromotionExpense: 0,
				cardRealPrice: 0,
				xbedPromotionExpense: 0,
				platformPrice: 0,
				promotionExpenseBack: 0,
			}
			this.financeInfo = {
				orgActualCheckinTime: '',
				orgActualCheckoutTime: '',
				orgPreCheckinTime: '',
				orgPreCheckoutTime: '',
				orgRoomPrice: 0,
				orgOwnerBear: 0,
				orgXbedBear: 0,
				orgShouldPay: 0,
				orgChannelCommission: 0,
				orgOtherChannelExpenses: 0,
				orgOwnerPromotionExpense: 0,
				orgXbedPromotionExpense: 0,
				orgCardRealPrice: 0,
				orgReceivedPrice: 0,
				orgSettlementPrice: 0,
				orgPlatformPrice: 0,
				orgPromotionExpenseBack: 0,
				showCheckinTime:'',
				showCheckoutTime:''
			}
			this.financeArr = ['', '']
		},
		async getFinanceInfo( checkinInfoId ) {
			this.initModelDate();
			let resp = ( await API.omsAPI[this.env].order.orderApi(
				{
					url: '/api/adjustment/getAdjustmentConsumptionsForAnalysis',
					payNo: this.stateDetailData.baseInfo.payNo, //'181211161108715416',
					checkinInfoId: checkinInfoId, //346016
				},
				'get',
				this.token
			) ).data
			if ( resp.retCode || !resp.checkinId ) {
				this.$Notice.error( {
					title: '接口错误或不可修正',
					desc: resp.msg || JSON.stringify( resp )
				} )
				return
			}
			this.defaultFinance = resp
			let financeKeys = new Set( Object.keys( this.financeInfo ) )
			financeKeys.forEach( key => {
				resp[key] && ( this.financeInfo[key] = resp[key] )
			} )
			let cusKeys = new Set( Object.keys( this.cus ) )
			cusKeys.forEach( key => {
				console.info( key )
				let pKey = 'org' + key.slice( 0, 1 ).toUpperCase() + key.slice( 1 );
				resp[pKey] && ( this.cus[key] = ( resp[pKey] / 100 ).toFixed( 2 ) )
			} )
			// Moment(this.financeArr[0]).format('YYYY-MM-DD')
			this.financeArr = [Moment( resp.showCheckinTime ).format( 'YYYY-MM-DD' ), resp.showCheckoutTime ? Moment( resp.showCheckoutTime ).format( 'YYYY-MM-DD' ) : ""]
			this.$refs.formValidate.resetFields();
			this.correction.display = true
		},
		datedifference( sDate1, sDate2 ) {    //sDate1和sDate2是2006-12-18格式  
			let dateSpan, iDays;
			if ( !sDate1 || !sDate2 ) return 0
			sDate1 = Date.parse( sDate1 );
			sDate2 = Date.parse( sDate2 );
			dateSpan = sDate2 - sDate1;
			dateSpan = Math.abs( dateSpan );
			iDays = Math.floor( dateSpan / ( 24 * 3600 * 1000 ) );
			return iDays
		},
		dateDiffRange( sDate1, sDate2 ) {    //sDate1和sDate2是2006-12-18格式  
			let dateSpan, iDays;
			if ( !sDate1 || !sDate2 ) return 0
			sDate1 = Date.parse( sDate1 );
			sDate2 = Date.parse( sDate2 );
			dateSpan = sDate2 - sDate1;
			iDays = Math.floor( dateSpan / ( 24 * 3600 * 1000 ) );
			return iDays
		},
		// 限制输入数字位数
		limitNumber( value ) {
			const reg = /^()*(\d+)\.(\d\d).*$/
			if ( typeof value === 'string' ) {
				return !isNaN( Number( value ) ) ? value.replace( reg, '$1$2.$3' ) : ''
			} else if ( typeof value === 'number' ) {
				return !isNaN( value ) ? String( value ).replace( reg, '$1$2.$3' ) : ''
			} else {
				return ''
			}
		},
		preSubFinanceInfo() {

			let diff = {
				roomNightDiff: this.diffDays,//房晚差额 OK
				roomPriceDiff: this.roomPriceDiff,//房费原价(差额) OK
				ownerBearDiff: this.ownerBearDiff,//业主优惠(差额) OK
				xbedBearDiff: this.xbedBearDiff,//xbed承担优惠金额(差额) OK


				shouldPay: this.showPay,//应付 ？
				shouldPayDiff: this.shouldPayDiff,// 应付(差额) OK

				channelCommissionDiff: this.channelCommissionDiff,//OTA佣(差额) OK
				otherChannelExpensesDiff: this.otherChannelExpensesDiff,//渠道活动费(差额) OK
				ownerPromotionExpenseDiff: this.ownerPromotionExpenseDiff,//业主推广费(差额) OK
				cardRealPriceDiff: this.cardRealPriceDiff,//卡券金额(差额) OK
				xbedPromotionExpenseDiff: this.xbedPromotionExpenseDiff,//Xbed推广费(差额) OK

				receivedPrice: this.xbedReceived,//Xbed实收 ？
				receivedPriceDiff: this.receivedPriceDiff,//Xbed实收(差额) OK 

				settlementPrice: this.settlement,//结算金额 ？
				settlementPriceDiff: this.settlementPriceDiff,//结算金额(差额) OK

				platformPrice: this.cumPlatformPrice, //平台服务费
				platformPriceDiff: this.platformPriceDiff,//平台服务费(差额) OK

				promotionExpenseBack: this.cumPromotionExpenseBack,//推广费返还
				promotionExpenseBackDiff: this.promotionExpenseBackDiff,//推广费返还(差额) OK
			}

			let otherInfo = {
				actualCheckinTime: Moment( this.financeArr[0] ).format( 'YYYY-MM-DD' ),//实际开始时间
				actualCheckoutTime: Moment( this.financeArr[1] ).format( 'YYYY-MM-DD' ),//实际结束时间
				reason: this.formValidate.reason,
				payNo: this.stateDetailData.baseInfo.payNo,
				checkPayInfoId: this.checkPayInfoId,
				createName: this.username
			}
			let cus = {}
			Object.keys( this.cus ).forEach( key => {
				cus[key] = (this.cus[key] * 100).toFixed(0)
			} )
			let obj = Object.assign( {}, this.defaultFinance, this.financeInfo, cus, diff, otherInfo )
			if ( !obj.reason ) {
				this.$Notice.error( {
					title: '修正原因不能为空'
				} )
				this.$refs.correctionModal.buttonLoading = false
				return
			}
			if ( this.financeArr[0] === '' ) {
				this.$Notice.error( {
					title: '开始结束日期不能为空'
				} )
				this.$refs.correctionModal.buttonLoading = false
				return
			}
			if ( this.dateDiffRange( Moment( this.financeArr[0] ).format( 'YYYY-MM-DD' ), Moment( this.financeArr[1] ).format( 'YYYY-MM-DD' ) ) <= 0 ) {
				this.$Notice.error( {
					title: '结束日期必须大于开始日期！'
				} )
				this.$refs.correctionModal.buttonLoading = false
				return
			}
			this.subFinanceInfo( obj )
		},
		async subFinanceInfo( obj ) {
			let resp = ( await API.omsAPI[this.env].order.orderApi(
				{},
				'post',
				this.token,
				{
					url: '/api/adjustment/adjustmentCheckinInfo',
					...obj
				},
			) ).data
			this.$refs.correctionModal.buttonLoading = false
			if ( resp.retCode ) {
				this.$Notice.error( {
					title: resp.msg
				} )
				return
			}
			this.$Notice.success( {
				title: resp.msg || '操作成功。'
			} )

			this.clearObjReason()

			this.openDetailModal();
			this.listPayInfoReport();

			this.correction.display = false
		},
		clearObjReason() {
			this.formValidate.reason = ''
		},
		trimlrSpace( obj, name ) {
			obj[name] = obj[name].replace( /(^\s*)|(\s*$)/g, "" )
		},
	},
	computed: {
		diffDays: function () {
			let oldDiff = 0, newDiff = 0;
			if ( !this.financeInfo.showCheckoutTime ) { //无实际离开时间
				oldDiff = 0
			} else if ( this.financeInfo.showCheckinTime ) { //存在实际入住时间
				oldDiff = this.datedifference( Moment( this.financeInfo.showCheckinTime ).format( 'YYYY-MM-DD' ), Moment( this.financeInfo.showCheckoutTime ).format( 'YYYY-MM-DD' ) )
			} else (  //使用预约入住时间
				oldDiff = this.datedifference( Moment( this.financeInfo.showCheckinTime ).format( 'YYYY-MM-DD' ), Moment( this.financeInfo.showCheckoutTime ).format( 'YYYY-MM-DD' ) )
			)

			if ( this.financeArr[0] && this.financeArr[1] ) {
				newDiff = this.datedifference( Moment( this.financeArr[0] ).format( 'YYYY-MM-DD' ), Moment( this.financeArr[1] ).format( 'YYYY-MM-DD' ) )
			}
			return newDiff - oldDiff;
			// if(this.financeArr[0]) {
			//   newDiff = this.datedifference(Moment(this.financeArr[0]).format('YYYY-MM-DD'), Moment(this.financeArr[1]).format('YYYY-MM-DD'))
			// }else if(this.financeInfo.orgActualCheckinTime && this.financeInfo.orgActualCheckoutTime){
			//     newDiff = this.datedifference(Moment(this.financeInfo.orgActualCheckinTime).format('YYYY-MM-DD'), Moment(this.financeInfo.orgActualCheckoutTime).format('YYYY-MM-DD'))
			// }else {
			//   newDiff = 0
			// }
			// if(!this.financeInfo.orgActualCheckoutTime){
			//   return newDiff
			// }else{
			//   return newDiff - (this.datedifference(this.financeInfo.orgPreCheckinTime ? this.financeInfo.orgPreCheckinTime.split(" ")[0] : '', this.financeInfo.orgActualCheckoutTime ? this.financeInfo.orgActualCheckoutTime.split(" ")[0] : ''))
			// }
		},
		roomPriceDiff: function () {
			return -( this.financeInfo.orgRoomPrice - this.cus.roomPrice * 100 ).toFixed( 0 )
		},
		ownerBearDiff: function () {
			return -( this.financeInfo.orgOwnerBear - this.cus.ownerBear * 100 ).toFixed( 0 )
		},
		xbedBearDiff: function () {
			return -( this.financeInfo.orgXbedBear - this.cus.xbedBear * 100 ).toFixed( 0 )
		},
		shouldPayDiff: function () { // 应付
			return -( this.financeInfo.orgShouldPay - ( this.cus.roomPrice * 100 - this.cus.xbedBear * 100 - this.cus.ownerBear * 100 ) ).toFixed( 0 )
		},
		channelCommissionDiff: function () {
			return -( this.financeInfo.orgChannelCommission - this.cus.channelCommission * 100 ).toFixed( 0 )
		},
		otherChannelExpensesDiff: function () {
			return -( this.financeInfo.orgOtherChannelExpenses - this.cus.otherChannelExpenses * 100 ).toFixed( 0 )
		},
		ownerPromotionExpenseDiff: function () {
			return -( this.financeInfo.orgOwnerPromotionExpense - this.cus.ownerPromotionExpense * 100 ).toFixed( 0 )
		},
		cardRealPriceDiff: function () {
			return -( this.financeInfo.orgCardRealPrice - this.cus.cardRealPrice * 100 ).toFixed( 0 )
		},
		xbedPromotionExpenseDiff: function () {
			return -( this.financeInfo.orgXbedPromotionExpense - this.cus.xbedPromotionExpense * 100 ).toFixed( 0 )
		},
		receivedPriceDiff: function () { // xbed实收
			return -( this.financeInfo.orgReceivedPrice - ( this.cus.roomPrice * 100 - this.cus.xbedBear * 100 - this.cus.ownerBear * 100 - this.cus.channelCommission * 100 - this.cus.otherChannelExpenses * 100 ) ).toFixed( 0 )
		},
		settlementPriceDiff: function () {
			return -( this.financeInfo.orgSettlementPrice - ( this.cus.roomPrice * 100 - this.cus.ownerBear * 100 ) ).toFixed( 0 )
		},
		platformPriceDiff: function () {
			// return -(this.financeInfo.orgPlatformPrice - this.cus.platformPrice*100 ).toFixed(0)
			return -( this.financeInfo.orgPlatformPrice - this.cumPlatformPrice ).toFixed( 0 )
		},
		promotionExpenseBackDiff: function () {
			return -( this.financeInfo.orgPromotionExpenseBack - this.cumPromotionExpenseBack ).toFixed( 0 )
		},
		showPay: function () {//应付
			return ( ( this.cus.roomPrice - this.cus.ownerBear - this.cus.xbedBear ) * 100 ).toFixed( 0 )
		},
		xbedReceived: function () {//xbed实收
			return ( ( this.cus.roomPrice - this.cus.ownerBear - this.cus.xbedBear - this.cus.channelCommission - this.cus.otherChannelExpenses ) * 100 ).toFixed( 0 )
		},
		settlement: function () {//结算
			return ( ( this.cus.roomPrice - this.cus.ownerBear ) * 100 ).toFixed( 0 )
		},
		cumPlatformPrice: function () {//平台服务费
			return ( this.settlement * 0.07 ).toFixed( 0 )
		},
		cumPromotionExpenseBack: function () {//推广费返还
			if ( this.financeInfo.orgPlatformPrice == 0 || this.financeInfo.orgPlatformPrice == 0 || this.cumPlatformPrice == 0 ) return 0
			return ( this.financeInfo.orgPromotionExpenseBack / this.financeInfo.orgPlatformPrice * this.cumPlatformPrice ).toFixed( 0 )
		}
	},
	filters: {

		initPrice( val = 0 ) {
			return ( val / 100 ).toFixed( 2 )
		}
	}
};
</script>

<style lang="scss" scoped>
.table {
	width: 100%;
	.table-row {
		display: flex;
		padding: 8px;
		justify-content: space-around;
		text-align: center;
		border-width: 1px 1px 0 1px;
		border-color: #ccc;
		border-style: solid;
		div:first-child {
			width: 35%;
			height: 32px;
			line-height: 32px;
			// padding:5px;
		}
		div {
			width: 45%;
			height: 32px;
			line-height: 32px;
			// padding:5px;
		}
		div:last-child {
			width: 20%;
		}
	}
	.table-row:last-child {
		border-bottom: 1px solid #ccc;
	}
}
.add-wrapper {
	margin-top: 20px;
}

.tabs {
	margin-top: 20px;
}

.add-tabpane-distance {
	margin-left: 1px;
}

.table-wrapper {
	margin-top: 20px;
}

.add-distance {
	margin-top: 10px;
}

.text-align-right {
	text-align: right;
}
.text-align-left {
	text-align: left;
}

.text-align-center {
	text-align: center;
}
.wrap_myself {
	word-break: break-all;
	word-wrap: break-word;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/pay-order.vue